module.exports = __webpack_public_path__ + "static/img/组 3.cccbedd3.png";